import bankApis from "../../api/bank";

const state = () => ({
  banks: [],
  myBanks: [],
});

const bankModule = {
  namespaced: true,
  state: state,
  mutations: {
    SET_AlL_BANK_BANKS: (state, payload) => (state.banks = payload),
    SET_MY_BANKS: (state, payload) => (state.myBanks = payload),
  },

  actions: {
    async getMyBank({ commit }, payload) {
    if (localStorage.getItem('access_token')) {
        const { data } = await bankApis.getMyBank(payload,'?default=get');
        await commit("SET_MY_BANKS", data.data);
      }
    },
  }
};

export default bankModule;

// const getters = {};

// const mutations = {};

// const actions = {};

// export default {
//     namespaced: true,
//     state: state,
//     getters: getters,
//     actions: actions,
//     mutations: mutations
// };